import { initializeApp } from 'firebase/app'
import {getAuth} from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyBR2nVI4bbRsuufL52nMOOFC0FaPfFcJDc",
  authDomain: "qrmedisync.firebaseapp.com",
  projectId: "qrmedisync",
  storageBucket: "qrmedisync.appspot.com",
  messagingSenderId: "320251621800",
  appId: "1:320251621800:web:116a2aecc4665202ba6d9d",
  measurementId: "G-DN9NZFGD0R"
}

// Initialize Firebase and Firebase Authentication
const app = initializeApp(firebaseConfig)
const auth = getAuth(app)

export {auth}
